<template>
    <validation-observer v-slot="{ invalid, handleSubmit }" ref="feedbackValidator">
        <form @submit.prevent="handleSubmit(submit)" @keydown="errors.clear($event.target.name)">

            <time-input class="mb-3"
                :label="$t('feedbacks.log-time')"
                v-model="value.log_time_from"
                name="log_time_from"
                :error="errors.get('log_time_from')">
            </time-input>

            <!-- Learner page, no session -->
            <div class="form-group" v-if="learner && !session">
                <label class="form-control-label required">
                    {{ $t('feedbacks.position') }}
                </label>
                <div class="row">
                    <div class="col-6" v-for="(name, id) in positionNames" :key="id">
                        <base-radio :name="id" :value="value.simulation_role_1" @input="switchPositions($event, 1)">
                            {{ name }}
                        </base-radio>
                    </div>
                </div>
            </div>

            <!-- Learner page, with session -->
            <div class="form-group" v-if="learner && session">
                <label class="form-control-label required">
                    {{ $t('feedbacks.position') }}
                </label>

                <!-- Learner1 exists -->
                <div class="row" v-if="session.learner1">
                    <div class="col-6" v-for="(name, id) in positionNames" :key="id">
                        <base-radio :name="id" :value="value.simulation_role_1" @input="switchPositions($event, 1)">
                            {{ name }}
                        </base-radio>
                    </div>
                </div>

                <!-- Learner1 does not exist -->
                <div class="row" v-else>
                    <div class="col-6" v-for="(name, id) in positionNames" :key="id">
                        <base-radio :name="id" :value="value.simulation_role_2" @input="switchPositions($event, 2)">
                            {{ name }}
                        </base-radio>
                    </div>
                </div>
            </div>

            <!-- Instructor page, learner1 exists -->
            <div class="form-group" v-if="!learner && session.learner1">
                <div>
                    <label class="form-control-label">
                        {{ session.learner1.name }}
                    </label>
                    <div class="row mb-3">
                        <div class="col-6" v-for="(name, id) in positionNames" :key="id">
                            <base-radio :name="id" :value="value.simulation_role_1" @input="switchPositions($event, 1)">
                                {{ name }}
                            </base-radio>
                        </div>
                    </div>
                </div>
                <div v-if="session.learner2">
                    <label class="form-control-label">
                        {{ session.learner2.name }}
                    </label>
                    <div class="row">
                        <div class="col-6" v-for="(name, id) in positionNames" :key="id">
                            <base-radio :name="id" :value="value.simulation_role_2" :disabled="true">
                                {{ name }}
                            </base-radio>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Instructor page, learner1 does not exist -->
            <div class="form-group" v-if="!learner && !session.learner1">
                <div>
                    <label class="form-control-label">
                        {{ session.learner2.name }}
                    </label>
                    <div class="row mb-3">
                        <div class="col-6" v-for="(name, id) in positionNames" :key="id">
                            <base-radio :name="id" :value="value.simulation_role_2" @input="switchPositions($event, 2)">
                                {{ name }}
                            </base-radio>
                        </div>
                    </div>
                </div>
            </div>

            <div class="category form-category mb-4">
                <small><span class="text-warning">*</span> {{ $t('common.required-fields') }}</small>
            </div>

            <div class="text-center">
                <base-button native-type="submit"
                    type="primary"
                    :disabled="errors.any() || invalid"
                >
                    {{ value.id ? $t('common.update') : $t('common.create') }}
                </base-button>

                <base-button type="link" class="ml-auto" @click="modal.show = false">
                    {{ $t('common.cancel') }}
                </base-button>
            </div>

        </form>
    </validation-observer>
</template>

<script>
    export default {
        
        props: {

            value: {
                type: Object,
                required: true
            },

            errors: {
                type: Object,
                required: true
            },

            modal: {
                type: Object,
                required: true
            },

            positionNames: {
                type: Object,
                required: true
            },

            registration: {
                type: Object,
                required: true
            },

            session: {
                type: Object,
                default: null
            },

            learner: {
                type: Object,
                default: null
            },
        },

        created() {
            this.errors.setValidator('feedbackValidator', this)
        },

        watch: {

            modal(val) {
                // Set the default position when opening form.
                if (val.show && !this.value.id) {
                    this.value.simulation_role_1 = Object.keys(this.positionNames)[0]
                    if (Object.keys(this.positionNames).length > 1) {
                        this.value.simulation_role_2 = Object.keys(this.positionNames)[1]
                    }
                }
            }
        },

        methods: {

            switchPositions(value, learnerNum = 1) {
                const teammateNum = 3 - learnerNum
                this.value['simulation_role_'+learnerNum] = value

                if (Object.keys(this.positionNames).length > 1) {

                    // There are 2 positions. We switch.
                    if (value == Object.keys(this.positionNames)[0]) {
                        this.value['simulation_role_'+teammateNum] = Object.keys(this.positionNames)[1]
                    } else {
                        this.value['simulation_role_'+teammateNum] = Object.keys(this.positionNames)[0]
                    }
                } else {

                    // There is 1 position. We assign it to both values.
                    this.value['simulation_role_'+teammateNum] = Object.keys(this.positionNames)[0]
                }
            },

            submit() {
                this.$emit('input', { ...this.value})
            }
        }
    }
</script>
